import { render, staticRenderFns } from "./BaseFiltroExportacao.vue?vue&type=template&id=0a56516a"
import script from "./BaseFiltroExportacao.vue?vue&type=script&lang=js"
export * from "./BaseFiltroExportacao.vue?vue&type=script&lang=js"
import style0 from "./BaseFiltroExportacao.vue?vue&type=style&index=0&id=0a56516a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports